import { useSelector } from "react-redux"

const useDAuth = () => {
  return {
    ...useSelector((state) => ({
      isAuthLoading: state.dAuth.isAuthLoading,
      isAuthentication: state.dAuth.isAuthentication,
      isAuthenticationError: state.dAuth.isAuthenticationError,
    })),
  }
}

export default useDAuth
